import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useNavigation } from '../../../common/navigation';

export const ExamLinkRegister: React.FC<{
  examId: string;
  examNumber: number;
}> = props => {
  const nav = useNavigation();

  const handleOnClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    void nav.examTests(props.examId);
  };

  return (
    <>
      <OverlayTrigger overlay={<Tooltip>Badanie</Tooltip>}>
        <Button onClick={handleOnClick} variant="btn-info">
          <Icon.PeopleFill />
        </Button>
      </OverlayTrigger>
      {props.examNumber}
    </>
  );
};
